import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// CRITICAL FIX: Unregister all Service Workers to prevent fetch interception
// Service Worker was causing "Response body is already used" errors on API calls
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    if (registrations.length > 0) {
      console.log('[SW Cleanup] Unregistering all service workers...');
      registrations.forEach(registration => {
        console.log('[SW Cleanup] Unregistering:', registration.scope);
        registration.unregister();
      });
      console.log('[SW Cleanup] ✅ All service workers unregistered');
    } else {
      console.log('[SW Cleanup] No service workers found');
    }
  }).catch(err => {
    console.warn('[SW Cleanup] Failed to unregister service workers:', err);
  });
}

// Service Worker registration is DISABLED
// The app no longer needs offline caching - all API calls go directly to api.hayatfamily.app
// serviceWorkerRegistration.unregister();
